import { ApprovalInboxResponse } from "@/api/ApprovalInboxResponse";

export type ApprovalInboxSummary = {
  pendingTimesheets: number;
  pendingAbsences: number;
  pendingTotal: number;
  pendingTimesheetMinutes: number;
  pendingAbsenceDays: number;
  actionRequiredTimesheets: number;
  actionRequiredAbsences: number;
  actionRequiredTotal: number;
};

export const emptyApprovalInboxSummary = (): ApprovalInboxSummary => ({
  pendingTimesheets: 0,
  pendingAbsences: 0,
  pendingTotal: 0,
  pendingTimesheetMinutes: 0,
  pendingAbsenceDays: 0,
  actionRequiredTimesheets: 0,
  actionRequiredAbsences: 0,
  actionRequiredTotal: 0,
});

export const summarizeApprovalInbox = (
  inbox?: ApprovalInboxResponse | null,
): ApprovalInboxSummary => {
  if (!inbox) {
    return emptyApprovalInboxSummary();
  }

  const actionRequiredTimesheets = inbox.rejectedTimesheets.length;
  const actionRequiredAbsences = inbox.rejectedAbsences.length;
  const pendingTimesheets = inbox.pendingTimesheets.length;
  const pendingAbsences = inbox.pendingAbsences.length;

  return {
    pendingTimesheets,
    pendingAbsences,
    pendingTotal: pendingTimesheets + pendingAbsences,
    pendingTimesheetMinutes: inbox.pendingTimesheets.reduce(
      (sum, item) => sum + item.entry.minutes,
      0,
    ),
    pendingAbsenceDays: inbox.pendingAbsences.reduce(
      (sum, item) => sum + item.entry.days,
      0,
    ),
    actionRequiredTimesheets,
    actionRequiredAbsences,
    actionRequiredTotal: actionRequiredTimesheets + actionRequiredAbsences,
  };
};

export const hasApprovalInboxItems = (summary?: ApprovalInboxSummary | null): boolean =>
  !!summary && (summary.pendingTotal > 0 || summary.actionRequiredTotal > 0);

export const approvalInboxBadgeCount = (summary?: ApprovalInboxSummary | null): number =>
  summary ? summary.pendingTotal + summary.actionRequiredTotal : 0;
